var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"value":_vm.value,"headers":_vm.headers,"items":_vm.items,"items-per-page":_vm.itemsPerPage,"show-select":_vm.showSelect,"item-key":_vm.itemKey,"hide-default-footer":_vm.hideFooter},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }